import { useParams } from "react-router";
import RichViewer from "../components/HTMLeditor/Draft.viewer";
import { UseApi } from "../hooks/use-api";
import { GetProduct } from "../Services/lib/nft";
import { useEffect } from "react";

const TestPage = () => {
	const { id } = useParams();
	const [{ data }, getProduct] = UseApi({
		service: GetProduct,
	});

	useEffect(() => {
		console.log(data);
	}, [data]);

	useEffect(() => {
		console.log(id);
		if (id) {
			getProduct(id);
		}
	}, [id]);
	if (data) return <RichViewer data={data.drawHtml} />;
	else return "null";
};

export default TestPage;
